<template>
  <footer>
    <div class="main_footer">
      <div class="container">
        <div class="footer_social">
          <h3>Follow Us on</h3>
          <ul>
            <li>
              <a href="https://twitter.com/EthfighterC" target="_blank"
                ><img src="../assets/images/twitter.png" alt=""
              /></a>
            </li>
            <li>
              <a href="https://t.me/ethfighter" target="_blank"
                ><img src="../assets/images/telegram.png" alt=""
              /></a>
            </li>
            <li>
              <a href="https://discord.gg/Fm3QgwQ" target="_blank"
                ><img src="../assets/images/discord.png" alt=""
              /></a>
            </li>
            <li>
              <a href="https://medium.com/@info_74893" target="_blank"
                ><img src="../assets/images/medium-icon.png" alt=""
              /></a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/ETH-Fighter-103401854807973"
                target="_blank"
                ><img src="../assets/images/facebook.png" alt=""
              /></a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/channel/UC7ZjFYlK_lF8VKh3-LDjCNA"
                target="_blank"
                ><img src="../assets/images/you-tube.png" alt=""
              /></a>
            </li>
          </ul>
        </div>

        <!-- <div class="availableon mb-4">
                   <h3>Available on</h3>
                  <ul>
                    <li><span>Available on Steam</span><img src="../assets/images/icons1.png"></li>
                    <li><span>Apple IOS Coming Soon</span><img src="../assets/images/icons2.png"></li>
                    <li><span>Play Store Coming Soon</span><img src="../assets/images/icons3.png"></li>
                  </ul>
                </div> -->

        <div class="footer_link mb-4">
          <h3>Recommendations</h3>
          <ul>
            <li><a target="_blank" href="https://metamask.io">Metamask</a></li>
            <li>
              <a target="_blank" href="https://trustwallet.com/"
                >Trust Wallet</a
              >
            </li>
          </ul>
        </div>
        <div class="footer_link">
          <ul>
            <li><router-link to="presale">Presale</router-link></li>
            <li>
              <a href="https://www.ethfighter.com/guide.php" target="_blank"
                >Characters</a
              >
            </li>
            <li>
              <a
                href="https://www.ethfighter.com/characters.php"
                target="_blank"
                >Guides</a
              >
            </li>
            <!-- <li><a href="#">Bounty</a></li>
                        <li><router-link to="media">Media</router-link></li> -->
            <li><router-link to="faq">Faqs</router-link></li>
            <li><a href="https://ethfighter.medium.com/">blog</a></li>
            <!-- <li><router-link to="contact">Contact</router-link></li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="container">
        <article class="row">
          <aside class="col-md-6">
            <p>©ETHFighter.com. ALL RIGHTS RESERVED.</p>
          </aside>
          <aside class="col-md-6">
            <ul>
              <li>
                <a href="https://ethfighter.com/term-of-use.php"
                  >Terms of Use
                </a>
              </li>
              <li><a href="#">Privacy Policy </a></li>
              <li>
                <a href="https://ethfighter.com/disclaimer.php">Disclaimer</a>
              </li>
            </ul>
          </aside>
        </article>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
</style>
